import { infiniteQueryOptions } from "@tanstack/react-query";
import { retrieveFiles } from "@/lib/data/requests/files/canonical-files";
import type { FileDestination } from "@/lib/data/schemas/files";
import { queryKeys } from "@/lib/data/static/query-keys";

export const fileDuplicationDestinationOptions = (
  destination: FileDestination,
) =>
  infiniteQueryOptions({
    queryKey: [queryKeys.files, "duplication-destinations", destination],
    initialPageParam: undefined as string | undefined,
    queryFn: ({ pageParam }) => retrieveFiles(destination, pageParam),
    getNextPageParam: (page) => page.nextCursor ?? undefined,
  });
